export type TemplateType = "form" | "media" | "model";

type TypeIconProps = {
  readonly className?: string;
  readonly size?: "md" | "lg";
  readonly type: TemplateType;
};

const typeClasses = {
  form: "bg-blue-50 text-info",
  media: "bg-fuchsia-50 text-fuchsia-700",
  model: "bg-emerald-50 text-success",
} as const satisfies Record<TemplateType, string>;

const typeLetters = {
  form: "F",
  media: "M",
  model: "D",
} as const satisfies Record<TemplateType, string>;

const sizeClasses = {
  md: "h-6 w-6 rounded text-[11px]",
  lg: "h-8 w-8 rounded-md text-sm",
} as const;

export function TypeIcon({ className = "", size = "md", type }: TypeIconProps) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center font-bold ${typeClasses[type]} ${sizeClasses[size]} ${className}`}
    >
      {typeLetters[type]}
    </span>
  );
}
